// PushNotificationHandler.js
'use strict';
import { connect } from 'react-redux';

import PushNotificationHandler from '../component/PushNotificationHandler.jsx';

import { PUSHY_APP_ID } from '../RemoteConfigKeys.js';
import setFcmToken from '../action/setFcmToken.js';
import setPushyToken from '../action/setPushyToken.js';
import submitPushNotificationToken from '../action/submitPushNotificationToken.js';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { push } from '../action/navigationAction.js';

const mapStateToProps = state => {
  const userId = getMeData(state, 'id');
  return {
    isAuthed: Boolean(userId),
    fcmToken: getMeData(state, 'fcmToken'),
    pushyToken: getMeData(state, 'pushyToken'),
    permission: getOperationData(state, ['permission'], 'notification'),
    pushyAppId: getRemoteConfigData(state, PUSHY_APP_ID),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    submitPushNotificationToken: ({ fcmToken, pushyToken } = {}) =>
      dispatch(submitPushNotificationToken({ fcmToken, pushyToken })),
    setFcmToken: () => dispatch(setFcmToken()),
    setPushyToken: () => dispatch(setPushyToken()),
    push: (...args) => dispatch(push(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PushNotificationHandler);
